import {tokens} from '@commercial-helios/ui/theme'
import styled from 'styled-components'

import {TitleLayout} from '@helios/shared/styles/grid'
import mq from '@helios/shared/utils/media-query'

export const VideoTitle = styled(TitleLayout)`
    margin-bottom: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-bottom: ${tokens.spacing40};
    }
`
